import { useFormik } from 'formik';

import { initialValues } from './formData';

import { Product } from '../../../../../shared/types/systemConfiguration/products';

export const useProductFilters = (onFilter?: (data: Product) => void) => {
    const onSubmit = (data: Product) => {
        if (onFilter) onFilter(data || {});
    };

    const formik = useFormik({
        initialValues,
        onSubmit,
    });

    return {
        formik,
    };
};
